module.exports = __webpack_public_path__ + "img/checkbox.53677f68.svg";